export function submitOnEnter(event, idButton) {
  if (event.key === "Enter") {
    event.preventDefault();
    document.getElementById(idButton).click();
  }
}
